import { Log } from "../interface";
import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function logLogin(): Promise<void | Log | null> {
    if (api.clientApi) {
        await api.clientApi.clientAuditlogLogin(store.db ? store.db : "", "Login").then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }
            }
        });
    }
}

export { logLogin };
